/* LograFit — landing del Batido Verde. Marca la pagina y anima lo que lo pida. */
(function () {
  if (window.lfLandingInit) return;
  window.lfLandingInit = true;

  var marcar = function () { document.body.classList.add('lf-page'); };
  if (document.body) marcar(); else document.addEventListener('DOMContentLoaded', marcar);

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function observar(raiz) {
    var items = (raiz || document).querySelectorAll('.lf-reveal:not([data-lf-seen])');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); el.dataset.lfSeen = '1'; });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    items.forEach(function (el) { el.dataset.lfSeen = '1'; io.observe(el); });
  }

  /* Arrastre con el raton: en escritorio no hay gesto tactil y el carrusel
     solo se podia mover con los puntos. */
  function arrastre(car) {
    if (car.dataset.lfDrag) return;
    car.dataset.lfDrag = '1';
    var activo = false, x0 = 0, s0 = 0, movido = 0;
    car.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      activo = true; movido = 0;
      x0 = e.clientX; s0 = car.scrollLeft;
      car.classList.add('is-dragging');
      car.setPointerCapture(e.pointerId);
    });
    car.addEventListener('pointermove', function (e) {
      if (!activo) return;
      var d = e.clientX - x0;
      movido = Math.max(movido, Math.abs(d));
      car.scrollLeft = s0 - d;
      e.preventDefault();
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      car.addEventListener(ev, function (e) {
        if (!activo) return;
        activo = false;
        car.classList.remove('is-dragging');
        try { car.releasePointerCapture(e.pointerId); } catch (err) {}
      });
    });
    /* un arrastre no debe contar como clic (p. ej. sobre el boton de play) */
    car.addEventListener('click', function (e) {
      if (movido > 6) { e.stopPropagation(); e.preventDefault(); movido = 0; }
    }, true);
  }

  /* Movimiento automatico, lento y en bucle. Se detiene mientras el visitante
     toca el carrusel o hay un video sonando, y respeta "reducir movimiento". */
  function autoCarrusel(car) {
    if (car.dataset.lfAuto) return;
    car.dataset.lfAuto = '1';
    var vel = parseFloat(car.dataset.lfVel || '0.35');
    if (!vel || reduce) return;
    var pausado = false, visible = false, snap = getComputedStyle(car).scrollSnapType;
    ['pointerenter', 'pointerdown', 'focusin'].forEach(function (ev) {
      car.addEventListener(ev, function () { pausado = true; car.style.scrollSnapType = snap; });
    });
    ['pointerleave', 'focusout'].forEach(function (ev) {
      car.addEventListener(ev, function () { pausado = false; });
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; },
        { threshold: 0.25 }).observe(car);
    } else { visible = true; }

    function paso() {
      var hayVideo = !!car.querySelector('video:not([paused])') &&
                     [].some.call(car.querySelectorAll('video'), function (v) { return !v.paused; });
      if (visible && !pausado && !hayVideo) {
        car.style.scrollSnapType = 'none';
        var max = car.scrollWidth - car.clientWidth;
        if (max > 2) {
          var x = car.scrollLeft + vel;
          if (x >= max - 0.5) { x = 0; }
          car.scrollLeft = x;
        }
      }
      requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }

  function carruseles(raiz) {
    (raiz || document).querySelectorAll('[data-lf-car]:not([data-lf-ready])').forEach(function (car) {
      car.dataset.lfReady = '1';
      arrastre(car);
      autoCarrusel(car);
      var dots = car.parentElement.querySelector('[data-lf-dots]');
      if (!dots) return;
      var botones = [].slice.call(dots.children);
      var ir = function (i) { car.scrollTo({ left: i * car.children[0].offsetWidth + i * 12, behavior: reduce ? 'auto' : 'smooth' }); };
      botones.forEach(function (b, i) { b.addEventListener('click', function () { ir(i); }); });
      arrastre(car);
      autoCarrusel(car);
      var marcarDot = function () {
        var ancho = car.children[0].offsetWidth + 12;
        var i = Math.round(car.scrollLeft / ancho);
        botones.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      };
      car.addEventListener('scroll', marcarDot, { passive: true });
      marcarDot();
    });
  }

  function iniciar(raiz) { observar(raiz); carruseles(raiz); }

  function arrancar() { try { iniciar(); } catch (e) {} }
  arrancar();
  document.addEventListener('DOMContentLoaded', arrancar);
  window.addEventListener('load', arrancar);
  [300, 1200, 3000].forEach(function (ms) { setTimeout(arrancar, ms); });
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();


/* Videos de la landing: play manual en el UGC y boton de sonido en los reels. */
(function () {
  if (window.lfVideoInit) return;
  window.lfVideoInit = true;
  /* Las funciones son idempotentes (marcan lo ya enganchado), asi que se puede
     reintentar sin miedo: la seccion base va arriba del template y se ejecuta
     antes de que existan los videos. */

  /* Los videos van con preload="none": hay que pedir la carga antes del primer play. */
  function preparar(v) {
    if (v.dataset.lfCargado) return;
    v.dataset.lfCargado = '1';
    v.preload = 'auto';
    try { v.load(); } catch (e) {}
  }

  function pausarTodos(menos) {
    document.querySelectorAll('.lf-ugc video, .lf-reel video').forEach(function (v) {
      if (v === menos) return;
      if (!v.paused && !v.autoplay) { v.pause(); }
      var t = v.closest('.lf-ugc');
      if (t && v !== menos) t.classList.remove('is-playing');
    });
  }

  /* Los reels solo corren mientras se ven; si el visitante los pausa, se respeta. */
  function autoEnPantalla(raiz) {
    if (!('IntersectionObserver' in window)) return;
    var videos = (raiz || document).querySelectorAll('.lf-reel video:not([data-lf-auto])');
    if (!videos.length) return;
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        var v = e.target;
        var reel = v.closest('.lf-reel');
        if (e.isIntersecting) {
          if (!reel.dataset.lfManual) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.35 });
    videos.forEach(function (v) { v.dataset.lfAuto = '1'; io.observe(v); });
  }

  /* Portadas: el atributo poster se descarga al abrir la pagina aunque el video este mas abajo
     y tenga preload="none" (8 portadas, ~300 KB compitiendo con la foto 1). Van en data-lf-poster
     y se ponen cuando la tira se acerca a la pantalla. */
  function portadas(raiz) {
    var tiras = (raiz || document).querySelectorAll('[data-lf-portadas]:not([data-lf-pready])');
    if (!tiras.length) return;
    var poner = function (tira) {
      tira.querySelectorAll('video[data-lf-poster]').forEach(function (v) {
        v.poster = v.getAttribute('data-lf-poster');
        v.removeAttribute('data-lf-poster');
      });
    };
    if (!('IntersectionObserver' in window)) {
      tiras.forEach(function (t) { t.dataset.lfPready = '1'; poner(t); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        poner(e.target);
      });
    }, { rootMargin: '250px 0px' });
    tiras.forEach(function (t) { t.dataset.lfPready = '1'; io.observe(t); });
  }

  function iniciar(raiz) {
    portadas(raiz);
    autoEnPantalla(raiz);
    (raiz || document).querySelectorAll('.lf-ugc:not([data-lf-ready])').forEach(function (c) {
      c.dataset.lfReady = '1';
      var v = c.querySelector('video');
      var b = c.querySelector('.lf-play');
      if (!v || !b) return;
      b.addEventListener('click', function () {
        pausarTodos(v);
        preparar(v);
        v.muted = false;
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () { v.muted = true; v.play(); });
        c.classList.add('is-playing');
      });
      c.addEventListener('click', function (e) {
        if (e.target.closest('.lf-play')) return;
        if (!v.paused) { v.pause(); c.classList.remove('is-playing'); }
      });
      v.addEventListener('ended', function () { c.classList.remove('is-playing'); });
    });

    (raiz || document).querySelectorAll('[data-lf-toggle]:not([data-lf-ready])').forEach(function (b) {
      b.dataset.lfReady = '1';
      var reel = b.closest('.lf-reel');
      var v = reel && reel.querySelector('video');
      if (!v) { b.remove(); return; }
      if (!reel.parentElement.hasAttribute('data-lf-pausable')) { b.remove(); return; }
      b.addEventListener('click', function () {
        if (v.paused) { delete reel.dataset.lfManual; preparar(v); v.play(); }
        else { reel.dataset.lfManual = '1'; v.pause(); }
      });
      v.addEventListener('play', function () { reel.classList.remove('is-paused'); });
      v.addEventListener('pause', function () { reel.classList.add('is-paused'); });
      if (v.paused) reel.classList.add('is-paused');
    });

    (raiz || document).querySelectorAll('[data-lf-mute]:not([data-lf-ready])').forEach(function (b) {
      b.dataset.lfReady = '1';
      b.addEventListener('click', function () {
        var v = b.closest('.lf-reel').querySelector('video');
        if (!v) return;
        if (v.muted) { pausarTodos(v); v.muted = false; b.setAttribute('data-sonando', ''); v.play(); }
        else { v.muted = true; b.removeAttribute('data-sonando'); }
      });
    });
  }

  /* Al volver a la pestana, los reels visibles siguen donde estaban. */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    document.querySelectorAll('.lf-reel').forEach(function (reel) {
      if (reel.dataset.lfManual) return;
      var v = reel.querySelector('video');
      if (!v || !v.muted || !v.paused) return;
      var caja = reel.getBoundingClientRect();
      var visible = caja.top < window.innerHeight * 0.8 && caja.bottom > window.innerHeight * 0.2;
      if (visible) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
    });
  });

  function arrancar() { try { iniciar(); } catch (e) {} }
  arrancar();
  document.addEventListener('DOMContentLoaded', arrancar);
  window.addEventListener('load', arrancar);
  [300, 1200, 3000].forEach(function (ms) { setTimeout(arrancar, ms); });
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
